module.exports = __webpack_public_path__ + "img/bowen.ff3537d7.gif";